import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const ExternalCompanyManagementSection = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  background: ${({ theme }) => theme.colors.backgroundLila};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  width: 100%;
`;
